import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

const QuoteContainer = styled.div`
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-style: italic;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100vw;

  div {
    width: 30vw;
    padding: 10px;
    background-color: rgba(0,0,0,.3); 
  }
`;

const Quote = () => {
  const [swQuote, setSwQuote] = useState("LET THE FORCE BE WITH YOU");
  const [swQuoteAuthor, setSwQuoteAuthor] = useState("");
  const [qod, setQod] = useState("QUOTE OF THE DAY");
  const [qodAuthor, setQodAuthor] = useState("");

  useEffect(() => {

    function getSWQuote() {
      var quoteUrl =
        "https://swquotesapi.digitaljedi.dk/api/SWQuote/RandomStarWarsQuote";

      // TODO: Bryt ut api call
      // console.log(intl.locale)
      fetch(quoteUrl)
        .then((response) => {
          response.json().then((data) => {
            var content = data.content
              .replace(" ? ", " — ")
              .replace(" - ", " — ");
            var swArray = content.split(" — ");
            // console.log(swArray);
            setSwQuote(swArray[0]);
            setSwQuoteAuthor(" — " + swArray[1]);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    function getQod() {
      var quoteUrl = "https://quotes.rest/qod?language=en";

      // TODO: Bryt ut api call
      // console.log(intl.locale)
      fetch(quoteUrl)
        .then((response) => {
          response.json().then((data) => {
            // console.log(data.contents.quotes[0].quote);
            setQod(data.contents.quotes[0].quote);
            setQodAuthor(" — " + data.contents.quotes[0].author);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }

    getSWQuote();
    getQod();

    setInterval(() => {
      getSWQuote();
    }, 600000);
  }, []);

  return (
    <QuoteContainer>
      <div>
          <p>{qod}</p>
          <p>{qodAuthor}</p>
      </div>
      <div>
          <p>{swQuote}</p>
          <p>{swQuoteAuthor}</p>
      </div>
    </QuoteContainer>
  );
};

export default Quote;
